import { MenuComponent } from "_metronic/assets/ts/components"
import { KTSVG } from "_metronic/helpers"
import { PageTitle } from "_metronic/layout/core"
import { BtnLoader, BtnSubmitLoader, ColDef, FormCheckBox, FormDataPicker, FormInputNumber, FormRadio, FormSelect, PaginationStd, TableSetting, TableStd, ToolbarSetting, ToolbarStateHandler } from "app/components"
import { FormDropZoneUpload } from "app/components/formInputs/FormDropZoneUpload"
import { FormTextEditor } from "app/components/formInputs/FormTextEditor"
import { ModalBox } from "app/components/modals/ModalBox"
import { MsgBox } from "app/components/modals/MsgBox"
import { SeasonDto, KPIGradeFilterDto, SeasonService, ReportService, AnnouncementTypeEnum, Pattern, IFormAdditional, UserProfileDto, UserProfileService, UserProfileFilterDto, SpecialAssessDto, AssessTypeEnum, SpecialAssessRequestDto, SpecialService } from "app/modules/core"
import { catchErrorMsg } from "app/modules/core/helpers/Helper"
import { Formik, Form, Field, ErrorMessage } from "formik"
import moment from "moment"
import React from "react"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useSelector, shallowEqual } from "react-redux"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { RootState } from "setup"
import * as Yup from 'yup'

type AdditionalPageProps = {

}

// interface UserProfileIdSelectedDto {
//     userProfileId: string,
//     previousUserInfo: SpecialAssessRequestDto
// }
interface WraperUserProfileDto extends UserProfileDto {
    point: number
}

interface AdditionalPageState {
    isShowModal: boolean,
    totalRow: number,
    pageSize: number,
    currentPage: number,
    loading: boolean,
    loadingSave: boolean,
    userProfileIdSelected: WraperUserProfileDto[],
    isExceptedMode: boolean,
    dataToSave: SpecialAssessRequestDto[]
    restUserInfoToSave?: SpecialAssessRequestDto,
    restUserIdToIgnore?: string[]

}

const initDefaultPageState: AdditionalPageState = {
    isShowModal: false,
    totalRow: 0,
    pageSize: 10,
    currentPage: 1,
    loading: false,
    userProfileIdSelected: [],
    dataToSave: [],
    isExceptedMode: false,
    loadingSave: false,

}

const formSchema = Yup.object().shape({
    seasonId: Yup.number().moreThan(0).required('require'),
    title: Yup.string().required('require'),
    recordDate: Yup.date().required('require'),
    point: Yup.number().required('require'),
})

export const AdditionalPage: React.FC<AdditionalPageProps> = (props) => {
    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const navigate = useNavigate()


    const defaultFormData: IFormAdditional = {
        seasonId: lastSeason.id,
        assessTypeId: 0,
        title: "",
        point: 0,
        recordDate: new Date()
    }


    const [reload, setReload] = React.useState<{}>()
    const [userData, setUserData] = useState<WraperUserProfileDto[]>([])
    const [season, setSeason] = useState<SeasonDto[]>()
    const [searchParam, setSearchParam] = useState<UserProfileFilterDto>({
        page: 0,
        length: 10,
    })

    const [formData, setFormData] = useState<IFormAdditional>(defaultFormData)
    const [pageState, setPageState] = useState<AdditionalPageState>(initDefaultPageState)
    const [toolBarState, setToolBarState] = useState<ToolbarStateHandler>({
        forceClearSelected: {}
    })

    useMemo(() => {
        SeasonService.GetActiveSeasons().then(res => {
            setSeason(res.data.result)
        })
    }, [])




    const columnDef: ColDef<WraperUserProfileDto>[] = [
        {
            label: 'ลำดับ',
            renderItem: ({ item, index }) => item.id,
            hidden: true
        },
        {
            label: 'ID',
            renderItem: ({ item, index }) => item.employeeId,
        },
        {
            label: 'ชื่อ',
            renderItem: ({ item, index }) => <>{item.firstName + ' ' + item.lastName}</>,
        },
        {
            label: 'ตำแหน่ง',
            renderItem: ({ item, index }) => item.workingTypeCode,
            filterOption: [
                { value: 'All', label: 'All' },
                { value: 'FullTime', label: 'FullTime' },
                { value: 'PartTime', label: 'PartTime' },
            ],
        },
        {
            label: 'สาขา',
            renderItem: ({ item, index }) => item.affiliateCode,
            filterOption: [
                { value: 'SNH', label: 'SNH' },
                { value: 'SVH', label: 'SVH' },
            ],
        },
        {
            label: 'คะแนน',
            renderItem: ({ item, index }) => {
                return <div className="d-flex justify-content-center">
                    <span className="me-2" >{item.point}</span>
                    {item.point > 0 && <i className="fa-solid fa-eraser" style={{ color: "#ff0000", cursor: "pointer" }} onClick={(e) => handleRemoveItem(e, item.id)}></i>}
                </div>
            },

        },


    ]
    const onSaveChange = (e: any) => {
        // console.log(pageState)
        // return
        if (pageState.dataToSave.length === 0 && pageState.restUserInfoToSave === undefined) {
            toast.warning('No data to save.')
            return
        }

        setPageState({
            ...pageState,
            loadingSave: true
        })
        SpecialService.CreateSpeacialWithPerson({
            dataToSave: pageState.dataToSave,
            restUserInfoToSave: pageState.restUserInfoToSave,
            restUserIdToIgnore: pageState.restUserIdToIgnore
        }).then((res) => {
            toast.success('Save Success.')
            setPageState(initDefaultPageState)
            setReload({})
            setToolBarState({
                forceClearSelected: {}
            })
        }).catch((ex) => {
            toast.error(catchErrorMsg(ex))
            setPageState({
                ...pageState,
                loadingSave: false
            })
        })
    }

    const handleAdd = (selectedItem: WraperUserProfileDto[], isAllPageSelected?: boolean) => {

        setPageState({
            ...pageState,
            isShowModal: true,
            userProfileIdSelected: selectedItem,
            isExceptedMode: isAllPageSelected ?? false
        })
    }



    const CustomizeSelectionAction = (props: { selectedItem: WraperUserProfileDto[], isAllPageSelected?: boolean }) => {
        return <>
            <button
                type='button'
                className='btn btn-info me-2'
                onClick={() => handleAdd(props.selectedItem, props.isAllPageSelected)}
            >
                เพิ่มการประเมิน
            </button>

            <button
                type='button'
                className='btn btn-light '
                onClick={() => {
                    setToolBarState({
                        forceClearSelected: {}
                    })
                    setReload({})
                }}
            >
                <i className="fa-solid fa-rotate-right"></i>
            </button>
        </>
    }
    const tableSetting: TableSetting<WraperUserProfileDto> = {
        showColAction: false,
        showSelection: true,
        primaryKey: (item: WraperUserProfileDto) => item,
        onPageChange: ((e: any, page: number) => setSearchParam({
            ...searchParam,
            page
        }))
    }



    const CustomizeAddButton = () => {
        return <>
            <BtnLoader onClick={onSaveChange} loading={pageState.loadingSave} >Save Change</BtnLoader>
            <button className="btn btn-danger" onClick={() => {
                setPageState({
                    ...pageState,
                    dataToSave: [],
                    restUserInfoToSave: undefined,
                    restUserIdToIgnore: undefined
                })
                setReload({})

            }}>Clear</button>
        </>
    }
    const toolbarSetting: ToolbarSetting = {
        showBtnAdd: true,
        showFilter: true,
        showSearch: true,
        showBtnExport: false,
        btnAddText: 'Save Change',
        searchTextValue: '',
        customizeSelectionAction: (selected: any[], isAllPageSelected?: boolean) => <CustomizeSelectionAction selectedItem={selected} isAllPageSelected={isAllPageSelected} />,
        customizeAddButton: () => <CustomizeAddButton />,
        onBtnAddClick: undefined,
        onSearchTextChange: (e: any) => {
            e.preventDefault()
            if (e.target.value.length > 0) {
                setSearchParam((s) => ({ ...s, searchText: e.target.value, page: 1 }))
                setPageState((s) => ({ ...s, currentPage: 1 }))
            }
            if (e.target.value.length === 0) {
                setSearchParam((s) => ({ ...s, searchText: '', page: 1 }))
                setPageState((s) => ({ ...s, currentPage: 1 }))
            }
        },
        onFilterApply: (val: { label: string; value: any }[]) => {
            const worktype = val.find((x) => x.label === 'ตำแหน่ง')?.value
            const affiliateCode = val.find((x) => x.label === 'สาขา')?.value
            setSearchParam((s) => ({
                ...s,
                workingTypeCode: worktype ? worktype : undefined,
                affiliateCode: affiliateCode ? affiliateCode : undefined
            }))
        },
        toolbarState: toolBarState
    }

    useEffect(() => {
        const load = () => {
            setPageState({
                ...pageState,
                loading: true
            })
            UserProfileService.Search(searchParam).then((result) => {
                const row = result.data.result
                const wraperUserProfileDto: WraperUserProfileDto[] = row.map((item: UserProfileDto) => {

                    let newWrapUser: WraperUserProfileDto = {
                        point: 0,
                        id: "",
                        firstName: "",
                        lastName: "",
                        employeeId: "",
                        startWorkingDate: new Date(),
                        workingTypeCode: "",
                        affiliateCode: "",
                        roleCode: "",
                        avatar: "",
                        isActive: false,
                        email: ""
                    }
                    Object.assign(newWrapUser, item)
                    //if has selected all user point then display fake point excepted has before point
                    newWrapUser.point = pageState.dataToSave.find(x => x.userProfileId === item.id)?.point ??
                        (pageState.restUserIdToIgnore && pageState.restUserIdToIgnore.includes(item.id) ? 0 : pageState.restUserInfoToSave?.point) ?? 0

                    return newWrapUser;
                })
                setUserData(wraperUserProfileDto)

                setPageState({
                    ...pageState,
                    totalRow: result.data.totalRows,
                    loading: false
                })
                MenuComponent.reinitialization()
            }).catch((ex) => {
                toast.error(catchErrorMsg(ex))
                setPageState({
                    ...pageState,
                    loading: false
                })

            })
        }
        load()
    }, [searchParam, reload])

    const onSelectSeason = useCallback((seasonid: number) => {
        setSearchParam((s) => ({ ...s, seasonId: seasonid, page: 1 }))
    }, [])

    const mapDataToSave = (value: IFormAdditional, point: number, userProfileId?: string) => {
        const dataToSave: SpecialAssessRequestDto = {
            userProfileId: userProfileId,
            point: point,
            title: value.title,
            seasonId: value.seasonId,
            assessTypeId: AssessTypeEnum.spacial,
            recordDate: new Date(value.recordDate),
            file: null
        }
        return dataToSave
    }

    const handleApply = (value: IFormAdditional) => {

        if (!pageState.isExceptedMode && pageState.userProfileIdSelected.length > 0) {
            const dataToSave: SpecialAssessRequestDto[] = pageState.userProfileIdSelected.map((item => mapDataToSave(value, value.point, item.id)))
            const ids = dataToSave.map(x => x.userProfileId)
            const newDataSave = pageState.dataToSave.filter(x => !ids.includes(x.userProfileId)).concat(dataToSave)
            const newRestUserIgnore = pageState.restUserIdToIgnore && pageState.restUserIdToIgnore.filter(x => !ids.includes(x))
            setPageState((item) => ({
                ...item,
                dataToSave: newDataSave,
                isShowModal: false,
                userProfileIdSelected: [],
                restUserIdToIgnore: newRestUserIgnore
            }))


        } else if (pageState.isExceptedMode) {

            //remove excepttion user data from the list.
            let newDataToSave: SpecialAssessRequestDto[] = []
            let restUserIdToIgnore: string[] = []
            //clear all DataToSave insert excepted if have previous point insert previous
            //newDataToSave = []
            if (pageState.userProfileIdSelected.length > 0) {

                pageState.userProfileIdSelected.forEach(item => {
                    const hasUser = pageState.dataToSave.find(x => x.userProfileId && x.userProfileId === item.id);
                    if (hasUser) {
                        newDataToSave.push(hasUser)
                    } else if (pageState.restUserInfoToSave) {
                        const newAllUser = Object.assign({}, pageState.restUserInfoToSave)
                        newAllUser.userProfileId = item.id
                        newDataToSave.push(newAllUser)
                    } else {
                        restUserIdToIgnore.push(item.id)

                    }
                })

            }
            setPageState((item) => ({
                ...item,
                dataToSave: newDataToSave,
                isShowModal: false,
                userProfileIdSelected: [],
                restUserInfoToSave: mapDataToSave(value, value.point, undefined),
                restUserIdToIgnore: restUserIdToIgnore
            }))

        }

        setToolBarState({
            forceClearSelected: {}
        })
        setReload({})
    }
    // need to check all or not all and add delete.
    const handleRemoveItem = (e: any, id: string) => {
        e.preventDefault()
        if (!pageState.restUserInfoToSave) {
            setPageState((item) => ({
                ...item,
                dataToSave: pageState.dataToSave.filter(x => x.userProfileId !== id),
                isShowModal: false,
                userProfileIdSelected: []
            }))
        } else if (pageState.restUserInfoToSave) {
            let restUserIdToIgnore = pageState.restUserIdToIgnore ? pageState.restUserIdToIgnore : []
            const hasUser = pageState.dataToSave.find(x => x.userProfileId && x.userProfileId === id);
            if (hasUser) {
                restUserIdToIgnore.push(id)
            } else {
                restUserIdToIgnore = restUserIdToIgnore.filter(x => x !== id)
                restUserIdToIgnore.push(id)
            }
            setPageState({
                ...pageState,
                isShowModal: false,
                userProfileIdSelected: [],
                dataToSave: pageState.dataToSave.filter(x => x.userProfileId !== id),
                restUserIdToIgnore: restUserIdToIgnore
            })

        }

        setReload({})
    }
    const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string, txtEndCls?: string, textEnd?: string }> = (props) => {
        const labelCls = props.labelCls ?? 'col-lg-4 fw-bold'
        const inputCls = props.inputCls ?? 'col-lg-6'
        return (
            <div className='row mb-7'>
                <label className={labelCls}>{props.lable}</label>
                <div className={inputCls}>
                    <span className='fw-bolder fs-6 text-dark'>{props.children}</span>

                </div>
                {props.textEnd && <div className={props.txtEndCls}>
                    <span > {props.textEnd}</span>
                </div>}
            </div>
        )
    }

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>

                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                        {/* begin::Table */}
                        <TableStd
                            tableSetting={tableSetting}
                            toolbarSetting={toolbarSetting}
                            columns={columnDef}
                            data={userData}
                            isLoading={pageState.loading}
                            pageSetting={{
                                currentPage: searchParam.page,
                                totalRow: pageState.totalRow,
                                pageSize: pageState.pageSize,
                            }}


                        />
                        {/* end::Table */}
                    </div>

                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
            <ModalBox
                title={'เพิ่มหัวข้อประเมิน'}
                stateShow={pageState.isShowModal}
                onHide={() => setPageState({
                    ...pageState,
                    isShowModal: false
                })}
                showFooter={false}

            >
                <>
                    {/* begin::Scroll */}
                    <div className='card-body p-9'>

                        <Formik
                            enableReinitialize
                            initialValues={formData}
                            validationSchema={formSchema}
                            onSubmit={handleApply}
                        //validate={(val) => console.log(val)}
                        >
                            {({ values, handleSubmit, setFieldValue, errors, touched }) => (
                                <Form>
                                    <>
                                        {/* begin::Scroll */}
                                        <div className='card-body p-9'>
                                            <CellStyle lable='Season'>
                                                <Field
                                                    as='select'
                                                    name='seasonId'
                                                    className={
                                                        'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                        (errors.seasonId && touched.seasonId ? ' is-invalid' : '')
                                                    }
                                                    disabled={true}
                                                    source={season && season.map(item => ({ id: item.id, label: item.title }))}
                                                    component={FormSelect}
                                                />
                                                <ErrorMessage name={`title`} component='div' className='text-danger' />
                                            </CellStyle>

                                            <CellStyle lable='หัวข้อการประเมิน'>
                                                <Field
                                                    as='textarea'
                                                    autoComplete='off'
                                                    name='title'
                                                    className={
                                                        'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                        (errors.title && touched.title ? ' is-invalid' : '')
                                                    }
                                                    rows={3}
                                                />
                                                <ErrorMessage name={`title`} component='div' className='text-danger' />
                                            </CellStyle>
                                            <CellStyle lable='วันที่'>
                                                <Field
                                                    as='text'
                                                    name='recordDate'
                                                    className={
                                                        'form-control form-control-solid' +
                                                        (errors.recordDate && touched.recordDate ? ' is-invalid' : '')
                                                    }
                                                    value={moment(values.recordDate).format('DD/MM/YYYY')}
                                                    onDateChange={(value: Date, e: any) => {
                                                        setFieldValue('recordDate', value)
                                                    }}
                                                    minDate={new Date(lastSeason.periodStart)}
                                                    maxDate={new Date(lastSeason.periodEnd)}
                                                    component={FormDataPicker}
                                                />
                                                {/* <ReactCalendar/> */}
                                                <ErrorMessage name={`recordDate`} component='div' className='text-danger' />
                                            </CellStyle>

                                            <CellStyle lable='จำนวนคะแนน'>
                                                <Field
                                                    name='point'
                                                    className={
                                                        'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                        (errors.point && touched.point ? ' is-invalid' : '')
                                                    }
                                                    maxLength={18}
                                                    pattern={Pattern.Number2DigitMinus}
                                                    component={FormInputNumber}
                                                />
                                                <ErrorMessage name={`point`} component='div' className='text-danger' />
                                            </CellStyle>


                                        </div>
                                        {/* end::Scroll */}
                                        <div className='card-footer d-flex py-6 px-9'>

                                            <BtnSubmitLoader loading={pageState.loading} submitText="Apply" />
                                            <button className='btn btn-light' onClick={(e) => {
                                                e.preventDefault()
                                                setPageState({
                                                    ...pageState,
                                                    isShowModal: false
                                                })

                                            }}> Close</button>
                                        </div>


                                    </>

                                </Form>
                            )}
                        </Formik>
                    </div>
                </>

            </ModalBox>
        </>
    )
}